// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentsV1GeneratePdfFromHtmlSaveSaveResponse {
    static getAttributeTypeMap() {
        return DocumentsV1GeneratePdfFromHtmlSaveSaveResponse.attributeTypeMap;
    }
}
DocumentsV1GeneratePdfFromHtmlSaveSaveResponse.discriminator = undefined;
DocumentsV1GeneratePdfFromHtmlSaveSaveResponse.additionalProperties = false;
DocumentsV1GeneratePdfFromHtmlSaveSaveResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=documentsV1GeneratePdfFromHtmlSaveSaveResponse.js.map